'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';

// Sample data: Retention rate over time
const retentionTrendData = [
  { name: 'Q1 2024', retention: 88 },
  { name: 'Q2 2024', retention: 90 },
  { name: 'Q3 2024', retention: 92 },
  { name: 'Q4 2024', retention: 94 },
  { name: 'Q1 2025', retention: 93 },
  { name: 'Q2 2025', retention: 95 },
];

// Sample data: Retention by tenure
const tenureCohortData = [
  { name: '0-6mo', retention: 85 },
  { name: '6-12mo', retention: 90 },
  { name: '1-2yr', retention: 94 },
  { name: '2-3yr', retention: 96 },
  { name: '3-5yr', retention: 97 },
  { name: '5yr+', retention: 98 },
];

export function TeamRetentionTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 Team Retention Trend</h3>
      <MetricLineChart
        data={retentionTrendData}
        lines={[
          { dataKey: 'retention', name: 'Retention Rate (%)', color: '#6FCF97' },
        ]}
        xAxisLabel="Quarter"
        yAxisLabel="Retention Rate (%)"
        targetLine={90}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing improvement from 88% to 95% retention over 6 quarters.
        The green line represents the Good threshold (90%). Maintaining above 90%
        indicates healthy team stability and culture. The slight dip in Q1 2025 is
        within normal variation.
      </p>
    </div>
  );
}

export function TeamRetentionGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Retention Rate</h3>
      <MetricGauge
        value={95}
        max={100}
        label="12-Month Retention Rate"
        unit="%"
        ranges={[
          { min: 0, max: 85, color: '#EB5757', label: 'Poor' },
          { min: 85, max: 90, color: '#F2C94C', label: 'Concerning' },
          { min: 90, max: 95, color: '#4A90E2', label: 'Good' },
          { min: 95, max: 100, color: '#6FCF97', label: 'Excellent' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current retention rate of 95% is Excellent. This indicates strong team health,
        culture, and leadership. Continue investing in career development, compensation,
        and work-life balance to maintain this level.
      </p>
    </div>
  );
}

export function RetentionByCohort() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">👥 Retention by Tenure</h3>
      <MetricLineChart
        data={tenureCohortData}
        lines={[
          { dataKey: 'retention', name: 'Retention Rate (%)', color: '#E89841' },
        ]}
        xAxisLabel="Time with Company"
        yAxisLabel="Retention Rate (%)"
        targetLine={90}
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Retention improves significantly after the first year. The 0-6 month cohort at 85%
        suggests onboarding improvements could help. Engineers who make it past 1 year show
        excellent retention (94%+), indicating strong culture fit and satisfaction once
        established.
      </p>
    </div>
  );
}
